import React, { FC, useContext, useEffect, useState } from "react";
//import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";

//import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
//import Avatar from "./Avatar";
//import FooterNav from "components_custom/FooterNav/FooterNav";
import { useNavigate, useParams } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";

import { PhoneInput } from 'react-international-phone';
import { GlobalDataContext } from "contexts/GlobalData";
import { requestAPI } from "utils/api";
import Input from "shared/Input/Input";
import { UIContext } from "contexts/UIContext";
import { ArrowSmallLeftIcon } from "@heroicons/react/24/outline";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

const ReservationPhoneNumber = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}: any) => {

	const { id, idx } = useParams();

	const navigate = useNavigate ();

	const { 
		initData,
		setInitData,
	} = useContext (GlobalDataContext);

	const [info, setInfo] = useState <any> ({});
	const [phoneNumber, setPhoneNumber] = useState <any> ("");

	const {
		toast,
	} = useContext(UIContext);  

	useEffect(()=>{
		
		if (initData.token_info.permission_group === "guest") {

			navigate('/me')	
		} else {
			(async () => {

				const res: any = await requestAPI('GET', `v1/reserve/${id}`, null);
				
				
				setInfo(res);
				setPhoneNumber(res.data.info.traveler[idx as any].phoneNumberlast4);
				const traveler = res.data.info.traveler[Number(idx)];

				
			})();
		}
		
	}, []);

	const [seconds, setSeconds] = useState(0);
	const [code, setCode] = useState('');
	const [phone, setPhone] = useState('');
	const [countryCallingNumber, setCountryCallingNumber] = useState('');
	const [verificationCode, setVerificationCode] = useState('');
	const [isSending, setSending] = useState(false);

	const getRemainingSeconds = (scheduleUTC: string) => {
		// 일정 UTC 시간 (2024-09-05T03:02:37.446Z)
		//const scheduleUTC = res_info.data.updatedAt;

		// UTC 시간을 한국 시간으로 변환
		const scheduleDate = new Date(scheduleUTC);
		const koreaTimeOffset = 9 * 60; // 한국은 UTC+9
		const scheduleKoreaTime: any = new Date(scheduleDate.getTime() + koreaTimeOffset * 60 * 1000);

		// 현재 한국 시간
		const now = new Date();
		const nowKoreaTime: any = new Date(now.getTime() + koreaTimeOffset * 60 * 1000);

		// 두 시간 차이 계산 (밀리초)
		const timeDiff = nowKoreaTime - scheduleKoreaTime;
		const threeMinutesInMs = 3 * 60 * 1000;

		const remainingTimeInMs = threeMinutesInMs - timeDiff;
		const remainingSeconds = Math.floor(remainingTimeInMs / 1000);

		return remainingSeconds;
	};
	
	let timer: any = 0;

	

	

	const handleSubmit = async () => {
				
		const phoneNumber = phone.replace(`+${countryCallingNumber}`, '');

		if (phoneNumber === "") {
			toast ({type: 'warning', contents: '전화 번호를 입력해 주세요'});
			return 0;
		}

		const res_info: any = await requestAPI ('PUT', `v1/reserve/${id}/traveler-phonenumber/${idx}`, {
			countryCallingNumber,
			phoneNumber
		});
		
		if (res_info.code === 1000) {
			setInfo(res_info);
			setPhoneNumber(res_info.data.info.traveler[idx as any].phoneNumberlast4);
			navigate(`reservation/${id}`)
		} else if (res_info.code === 4000) {
			
			toast ({
				type: 'warning', 
				contents: '전화번호를 확인해 주세요'
			});
		}
		
	};
	
	

	const handleBack = () => {
		navigate(`/reservation/${id}`);
	}

	const changePhoneNumber = async (phone: string, meta: any) => {
		//console.log(meta)
		setCountryCallingNumber(meta.country.dialCode);
		setPhone(phone)
	};

	if (Object.keys(info).length === 0) {return (<></>)}

	return (
		<>
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>

				<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
					<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
						<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
							<button
								className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
								onClick={()=> handleBack()}
							>
								<ArrowSmallLeftIcon className="w-6 h-6" />
							</button>
							{/* <LikeSaveBtns /> */}
							<span
								className="text-xl"
							>
								뒤로
							</span>
						</div>
					</div>
				</div>

				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">
						<div className="mt-5" />
						<div
							className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
							>
							<div
								className={`max-w-2xl`}
							>
								<h2 className={`text-3xl md:text-4xl font-semibold`}>
									휴대폰 번호 수정
								</h2>
							</div>
						</div>

						<div className="mt-10" />

						<div>
							<span
								className="text-xl font-semibold text-slate-600"
							>
								변경하실 이름을 입력해주세요
							</span>
						</div>
						<div>
							<span 
								className="text-sm text-slate-600"
							>
								현재 등록된 전화번호는 [{phoneNumber}]이에요.
							</span>
						</div>

						<div className="mt-10" />

						
						<>
							<div className="grid grid-cols-1 gap-6">
								<label className="block">
									<span className="text-neutral-800 dark:text-neutral-200">
										전화번호
									</span>
									<PhoneInput
										style={
											{
												'--react-international-phone-country-selector-border-color-hover': "black",
												'--react-international-phone-background-color': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-900), var(--tw-bg-opacity))':'white',
												'--react-international-phone-country-selector-background-color-hover': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-900), var(--tw-bg-opacity))':'',
												'--react-international-phone-selected-dropdown-item-text-color': (localStorage.theme==="dark")? 'white':'',
												'--react-international-phone-dropdown-item-text-color': (localStorage.theme==="dark")? 'white':'',
												'--react-international-phone-selected-dropdown-item-background-color': (localStorage.theme==="dark")? 'rgba(var(--c-neutral-700), var(--tw-bg-opacity))':'',
											} as React.CSSProperties
										}
										inputClassName={
											"block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 text-sm font-normal h-11 px-4 py-3 mt-1"
										}
										defaultCountry="kr"
										value={phone}
										onChange={(phone, meta) => changePhoneNumber(phone, meta)}
									/>
								</label>
							</div>

							<div className="flex flex-col mt-12 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
								
								<ButtonPrimary
									onClick={() => handleSubmit()}
								>
									수정
								</ButtonPrimary>
							</div>
						</>
					</div>

				</div>
				
			</div>
		</>
	);
};

export default ReservationPhoneNumber;
